import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Demo mode — opt-in via `?demo=1` (persisted in sessionStorage so the flag
 * survives in-app navigation during a recording). Disable with `?demo=0`.
 *
 * In demo mode:
 *  - The "Resume" button does NOT open GitHub in a new tab. It triggers a
 *    soft success ripple + toast inside Trace so the camera stays put.
 *  - Empty session notes are pre-seeded with `DEMO_NOTE` (display-only,
 *    not persisted to MongoDB).
 *  - "Synced X ago" + sync/delete chrome is hidden so nothing looks stale.
 */
export const DEMO_NOTE = "Wiring AuthModal close handler";

export function useDemoMode() {
  const [params] = useSearchParams();
  const fromUrl = params.get("demo");
  const [demo, setDemo] = useState(() => {
    if (typeof window === "undefined") return false;
    if (fromUrl === "1") return true;
    if (fromUrl === "0") return false;
    return sessionStorage.getItem("trace_demo") === "1";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (fromUrl === "1") {
      sessionStorage.setItem("trace_demo", "1");
      setDemo(true);
    } else if (fromUrl === "0") {
      sessionStorage.removeItem("trace_demo");
      setDemo(false);
    }
  }, [fromUrl]);

  return demo;
}
